// src/components/Templates/CustomText/CustomText.component.tsx
import React from "react";
import S from "./CustomText.module.scss";

interface CustomTextProps {
    title: string;
    text?: {
        markup: string;
    };
}

const CustomText: React.FC<CustomTextProps> = ({ title, text }) => (
    <div>
        <h4 className={S.heading}>{title}</h4>
        {text?.markup && <div dangerouslySetInnerHTML={{ __html: text.markup }} />}
    </div>
);

export default CustomText;
